const ContactForm = require('../../components/contact-form');

module.exports = ContactForm;
